import { VEHICLE_SEARCH_URL } from '../endpoints'
import { SearchResponse } from '../types'

export const getSearchAPIData = async (): Promise<SearchResponse> => {
  const response = (await fetch(VEHICLE_SEARCH_URL).then((res) =>
    res.json(),
  )) as SearchResponse
  return response
}
